import React from 'react';
import { AggregatedSoldToAddress, AggregatedSoldToAddressV2 } from '@css-xp/ppc-sold-to-address-table';
import validator from 'validator';
import { emptyStateSearchTabs, PPC_TABS, TableHeading } from '@css-xp/ppc-common';

interface Props {
  searchTerm: string;
  partnerSearchContext: string;
  transactionAccountId: string;
  isOrgSearchEnabled?: boolean;
  isSoldToAddressArchivalEnabled?: boolean;
  isDuplicateCustomerNameEnabled?: boolean;
}

export const SoldToAddressesSearch = ({
  searchTerm,
  partnerSearchContext,
  transactionAccountId,
  isOrgSearchEnabled,
  isSoldToAddressArchivalEnabled,
  isDuplicateCustomerNameEnabled,
}: Props) => {
  const getSection = () => {
    return validator.isEmail(searchTerm) ? (
      <AggregatedSoldToAddressV2
        searchTerm={searchTerm}
        txaId={transactionAccountId}
        partnerSearchContext={partnerSearchContext}
        hideActions={true}
        hideEdit={true}
        showSearchBox={false}
        showAddAddressInRow={true}
        emptyState={emptyStateSearchTabs}
        heading={<TableHeading>{PPC_TABS.SOLD_TO_ADDRESS}</TableHeading>}
      />
    ) : (
      <AggregatedSoldToAddress
        searchTerm={searchTerm}
        txaId={transactionAccountId}
        partnerSearchContext={partnerSearchContext}
        hideActions={true}
        hideEdit={true}
        showSearchBox={false}
        showAddAddressInRow={true}
        emptyState={emptyStateSearchTabs}
        heading={<TableHeading>{PPC_TABS.SOLD_TO_ADDRESS}</TableHeading>}
        isOrgSearchEnabled={isOrgSearchEnabled}
        isSoldToAddressArchivalEnabled={isSoldToAddressArchivalEnabled}
        isDuplicateCustomerNameEnabled={isDuplicateCustomerNameEnabled}
      />
    );
  };

  return <div>{getSection()}</div>;
};

SoldToAddressesSearch.displayName = 'SoldToAddressesSearch';
